const customVideos = Array.from(document.querySelectorAll('.custom-video-element'));
const customVideoOverlays = Array.from(document.querySelectorAll('.custom-video-overlay'));

if(customVideos && customVideoOverlays) {
    customVideos.forEach(video => {
    const index = customVideos.indexOf(video);

    video.addEventListener('playing', () => {
        customVideoOverlays[index].style.display = "none";
    })
    })

    customVideoOverlays.forEach(overlay => {
    const index = customVideoOverlays.indexOf(overlay);
    
    overlay.addEventListener('click', () => {
        customVideos[index].play();  
    })
    })

    customVideoOverlays.forEach(overlay => {
    const index = customVideoOverlays.indexOf(overlay);

    overlay.addEventListener('touchend', () => {
        customVideos[index].play();  
    })
    })

}